import type { FundBasketAnalytics } from "creso-core/types";
import { withRelativeBarPct } from "creso-core/utils";
import { ExposureCard } from "web-core";

export function FundBasketExposureTables({
  top_holdings,
  top_sectors,
}: Pick<FundBasketAnalytics, "top_holdings" | "top_sectors">) {
  const stocksExposure = withRelativeBarPct(
    top_holdings.map((h) => ({ label: h.name, pct: h.weight }))
  );
  const sectorExposure = withRelativeBarPct(
    top_sectors.map((s) => ({ label: s.name, pct: s.weight }))
  );

  if (stocksExposure.length === 0 && sectorExposure.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
      <ExposureCard title="Stock Exposure" rows={stocksExposure} />
      <ExposureCard title="Sector Exposure" rows={sectorExposure} />
    </div>
  );
}
